import { render, staticRenderFns } from "./Letter.svg.vue?vue&type=template&id=14f109a6"
import script from "./Letter.svg.vue?vue&type=script&lang=ts"
export * from "./Letter.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f109a6')) {
      api.createRecord('14f109a6', component.options)
    } else {
      api.reload('14f109a6', component.options)
    }
    module.hot.accept("./Letter.svg.vue?vue&type=template&id=14f109a6", function () {
      api.rerender('14f109a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/Letter.svg.vue"
export default component.exports